import React, { memo } from 'react';
import PropTypes from 'prop-types';
import LazyImage from './_LazyImage.jsx';

const Image = (props) => {

  const { src, style = {}, lazy = false, ...rest } = props;
  if (!src) {
    return null;
  }

  return (
    <LazyImage
      src={src}
      style={style}
      lazy={lazy}
      {...rest}
    />
  );
};

Image.propTypes = {
  lazy: PropTypes.bool,
  className: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.object,
};

export default memo(Image);
